import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { useDataProvider, useTranslate } from "react-admin";

const TenantSelect = ({ selected, onChange, superTenantId }) => {
	const [tenants, setTenants] = useState([]);
	const translate = useTranslate();
	const dataProvider = useDataProvider();

	const handleChange = (e, value) => {
		onChange(value);
	};

	const fetchTenants = (e, search) =>
		dataProvider
			.getList("tenants", {
				pagination: { page: 1, perPage: 50 },
				filter: superTenantId
					? { fk_superTenantId: superTenantId, q: search }
					: { q: search },
				sort: {},
			})
			.then(response => {
				if (response && response.data) {
					setTenants(response.data);
					return response.data;
				}
				return [];
			});

	useEffect(() => {
		fetchTenants();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [superTenantId]);

	return (
		<Autocomplete
			value={selected}
			getOptionLabel={option => option && option.name}
			options={tenants}
			style={{ width: 300 }}
			renderInput={parameters => (
				<TextField {...parameters} label={translate("tenants.label")} variant="outlined" />
			)}
			onInputChange={fetchTenants}
			onChange={handleChange}
		/>
	);
};

export default TenantSelect;
